/* 用户 */
const indexTop = {
  images:"/static/img/index_banner.png"
}
const indexFunction = {
  text:["智慧校园云平台核心建设内容基于一线市场需求，围绕用户移动互联体验提升和大数据价值挖掘，搭建了“1+N系统+100子应用”业务架构；","K12智慧校园云平台的建设可以通过线下部署物联网智能硬件，按需开通应用，为K12智慧校园云平台投资方建设方、单个客户建设降低了成本。"],
  images:"/static/img/index_function.jpg"
}
const indexSolution = [
  {
    img:"/static/img/solution_2.png",
    text:"校园进出解决方案"
  },
  {
    img:"/static/img/solution_3.png",
    text:"智慧班牌管理解决方案"
  },
  {
    img:"/static/img/solution_4.png",
    text:"宿舍管理解决方案"
  },
  {
    img:"/static/img/solution_5.png",
    text:"智慧食堂解决方案"
  },
  {
    img:"/static/img/solution_6.png",
    text:"校园亲情电话解决方案"
  },
  {
    img:"/static/img/solution_7.png",
    text:"在线巡课解决方案"
  }
]
const indexCase = [
  "/static/img/index_case6.png","/static/img/index_case2.png","/static/img/index_case3.png","/static/img/index_case4.png","/static/img/index_case5.png","/static/img/index_case7.png"
]
const indexAbout = {
  text1:"厦门云知学科技有限公司总部及研发基地设立于风景秀丽的厦门软件园三期。公司技术和研发实力雄厚,致力于K12智慧校园建设,以教育信息化推动教育现代化,以可持续发展的智慧校园环境,推动智慧教育产业链的形成。",
  text2:"公司自成立以来,始终坚持以人才为本、诚信立业的经营原则,以“三全、两高、一大”教育信息化建设政策为指导,综合运用物联网、大数据处理技术、云计算技术和人工智能,服务于教育主管部门、学校、教师、家长、学生;助力实现中国教育信息化从应用整合阶段跨入融合创新阶段的变革,助力智慧校园生态圈的构建。"
}
const indexContact = [
  {
    img:"/static/img/contact_1.png",
    title:"地址/ADDRESS",
    text:"厦门市软件园三期C08"
  },
  {
    img:"/static/img/contact_2.png",
    title:"电话 / Tel",
    text:"18606059969"
  },
  {
    img:"/static/img/contact_3.png",
    title:"邮编 / ZIP",
    text:"361021"
  },
  {
    img:"/static/img/contact_4.png",
    title:"邮箱 / MAIL",
    text:"29939666@qq.com"
  }
]
const hardwareLeftMenu = [
  {
    id:1,
    text:"人脸识别一体机",
    img:"/static/img/hardware_left1.jpg",
  },
  {
    id:2,
    text:"人脸识别测温一体机",
    img:"/static/img/hardware_left2.jpg",
  },
  {
    id:3,
    text:"翼闸/摆闸",
    img:"/static/img/hardware_left3.jpg",
  },
  {
    id:4,
    text:"智慧班牌",
    img:"/static/img/hardware_left4.jpg",
  },
  {
    id:5,
    text:"人脸识别消费机",
    img:"/static/img/hardware_left5.jpg",
  },
  {
    id:6,
    text:"AI智能摄像机",
    img:"/static/img/hardware_left6.jpg",
  }
]
const solutionLeftMenu = [
  {
    id:1,
    text:"校园进出解决方案",
    img:"/static/img/solution_left1.jpg",
  },
  {
    id:2,
    text:"智慧班牌管理解决方案",
    img:"/static/img/solution_left2.jpg",
  },
  {
    id:3,
    text:"宿舍管理解决方案",
    img:"/static/img/solution_left3.jpg",
  },
  {
    id:4,
    text:"智慧食堂解决方案",
    img:"/static/img/solution_left4.jpg",
  },
  {
    id:5,
    text:"校园亲情电话解决方案",
    img:"/static/img/solution_left5.jpg",
  },
  {
    id:6,
    text:"在线巡课解决方案",
    img:"/static/img/solution_left6.jpg",
  },
]
const hardwareList = {
  one:'<div class="flex width100 justify-between"><div style="width: 670px;"><div class="size25">人脸识别一体机</div><div class="size20 padding-tb-sm font-strong">技术参数</div><div class="color-6 size18">操作系统：嵌入式Linux操作系统 <br>显示屏尺寸：7英寸 <br>屏幕比例：16:9 <br>分辨率：1024*600 <br>摄像头：200万像素1080P，自动对焦，适应120cm-200cm身高范围 <br>卡类型：13．56MHz Mifare卡、身份证序列号、CPU序列号 <br>刷脸验证时间 ：1：N人脸比对时间≤0.2S/人 <br>人脸验证准确率 ：≥99% <br>面部识别距离 ：大于2m <br>人脸容量： 5000张/50000张 <br>存储容量 ：50000张卡，100000条事件记录 <br>通讯方式： 10/100/1000Mbps自适应网口 <br>物理接口 ：RS485*1、Wiegand * 1(支持双向)、USB*2、电锁*1、门磁*1、报警输入*2、报警输出*1、开门按钮*1 <br>设备电源 ：DC 12V/3A（不带电源，集中供电） <br>设备功率 ：25W <br>相对湿度 ：0%至90%(在不凝结水滴状态下) <br>工作温度 ：-30℃～60℃ <br>使用环境 ： IP65</div></div><img src="/static/img/hardware_1.png" style="width: 186px; height: 380px; margin-top: 30px;"></div>',
  two:'<div class="flex width100 justify-between"><div style="width: 670px;"><div class="size25">人脸识别测温一体机</div><div class="size20 padding-tb-sm font-strong">技术参数</div><div class="color-6 size18">【测温、人脸识别】 <br>设备外观：采用7英寸触摸显示屏，200万像素双目摄像头，面部识别距离0.5m-1.5m； <br>设备容量：支持50000张人脸白名单，50000张卡，100000条记录存储；<br>体温检测：非接触式体温检测，温度检测距离在0.5m~1.5m之间，测温精度±0.5℃； <br>认证方式：支持人脸识别、刷卡、密码（密码）及组合认证方式，识别人员身份后获取该人员体温数据统一绑定；<br>通讯方式：有线网络； <br>设备接口： LAN*1；RS485*1；韦根*1；USB *2；门磁*1、开门按钮*1、报警输入*2；电锁*1、报警输出*1； <br>传感器类型：氧化钒(VOx)微测辐射热计（热成像测温）；<br>工作电压：DC 12V/2A，不自带电源； <br>使用环境：室内，无风环境； <br>安装方式：标配金属安装挂板，支持明装、86底盒安装； <br>外观尺寸：285*116.5*35mm <br>工作温度：0℃-50℃。</div></div><img src="/static/img/hardware_2.png" style="width: 166px; height: 407px; margin-top: 30px;"></div>',
  three:'<div class="flex width100 justify-between flex-direction"><div class="width100 flex justify-between"><div style="width: 420px;"><div class="size25">翼闸</div><div class="size20 padding-tb-sm font-strong">技术参数</div><div class="color-6 size18">尺寸：L1200*W300*H980mm； <br>材料SUS304 国标厚度：盖面1.5mm，机箱1.2mm； 通行人数：40人/分钟 ； <br>红外：对开配3对,断电自动打开,上电自动复位； <br>通行方向：双向读卡窗、方向指示； <br>翼门长度：28CM； <br>对开通道宽度：55CM； <br>工作环境：室内 /室外，室外底部要做隔潮安全岛。</div></div><img src="/static/img/hardware_3A.png" style="width: 321px; height: 174px; margin-top: 30px;"></div><div class="width100 flex justify-between" style="margin-top: 90px;"><div style="width: 420px;"><div class="size25">翼闸</div><div class="size20 padding-tb-sm font-strong">技术参数</div><div class="color-6 size18">尺寸：L1200*W300*H980mm； <br>材料SUS304 国标厚度：盖面1.5mm，机箱1.2mm； 通行人数：40人/分钟 ； <br>红外：对开配3对,断电自动打开,上电自动复位； <br>通行方向：双向读卡窗、方向指示； <br>翼门长度：28CM； <br>对开通道宽度：55CM； <br>工作环境：室内 /室外，室外底部要做隔潮安全岛。</div></div><img src="/static/img/hardware_3B.png" style="width: 357px; height: 258px; margin-top: 30px;"></div></div>',
  four:'<div class="flex width100 justify-between flex-direction"><div class="width100 flex justify-between"><div style="width: 470px;"><div class="size25">智慧班牌</div><div class="size20 padding-tb-sm font-strong">外观结构</div><div class="color-6 size18">1）产品功能：整机为安卓系统一体机，内置安卓系统、集成刷卡模块无需另配刷卡器、喇叭、无线功能等，可壁挂； <br>2）产品规格：显示尺寸21.5寸； <br>3）交互方式：触摸</div></div><img src="/static/img/hardware_4A.png" style="width: 287px; height: 226px; margin-top: 30px;"></div><div class="width100 flex justify-between" style="margin-top: 30px;"><div style="width: 100%"><div class="size20 padding-tb-sm">功能特性</div><div class="color-9 size18">1）21.5英寸TFT显示屏，分辨率≧1920*1080，屏幕比例16：9，显示颜色：8bitRGB，点间距：0.24795 mm×0.24795 mm；对比度：≧1000:1，亮度:≥280 cd/m²，可视角度（水平/垂直）:≧178°/178°，响应时间：≦14ms； <br>2）前置宽动态、≥200万像素摄像头，内置人脸比对算法（提供标准SDK供第三方调用） <br>3) 内置全向麦克风； <br>4) 支持ISO14443 TypeA、TypeB刷卡签到功能； <br>5) 2路USB接口，支持外接鼠标、U盘等； <br>6) 1路RJ45网线接口；<br>7) 标配电源开关按钮； <br>8) 内置WIFI无线功能，协议支持802.11 b/g/n；<img src="/static/img/hardware_4B.png" style="width: 276px; height: 287px; margin-top: 30px; float: right;"> <br>9) 喇叭：2x8Ω/2W 箱体喇叭； <br>10）输入电源：220V；功耗：≤30W。 <br>11）支持通过韦根信号控制门禁主机或开关量直接控制门锁 <br>12）产品尺寸：529.96mm×521.69mm×27.2mm <br><p class="size20 padding-tb-sm color-3 font-strong">操作系统</p> 1) Android智能操作系统6.0以上，稳定可靠； <br>2) 系统内存：≧2G内存保证系统最优性能； <br>3) 系统CPU：Cortex-A17,四核1.8GHZ主频保证系统快速运行； <br>4)）系统存储空间：内置16G emmc。</div></div></div></div>',
  five:'<div class="flex width100 justify-between flex-direction"><div class="width100 flex justify-between"><div style="width: 480px;"><div class="size25">人脸识别消费机</div><div class="size20 padding-tb-sm font-strong">技术参数</div><div class="color-6 size18">操作系统：Android 6.0.1 ； <br>主控芯片：RK3288（四核Cortex-A17+GPU Mail-T764,Up to 1.8G）； <br>内存：闪存：2GB； <br>存储：16GB； <br>显示屏：操作端：5寸高清屏； <br>用户端：8寸高清屏； <br>触摸：8寸支持触摸 <br>分辨率：5寸：480 * 800； 8寸：800 * 1280； <br>人脸识别：双目活体； <br>网络通讯方式：支持有线TCP、WIFI、4G； <br>支持SIM卡：移动、联通、电信4G； <br>4G通信支持以下频段：GPRS 850MHz /900MHz /1800MHz /1900MHz； <br>扬声器：单声道8R3W，响度90dB，无破音； <br>读卡频率：200ms； <br>卡片类型：IC卡； <br>IC卡支持13.56MHZ频段（ISO14443A读/写模式）； <br>感应距离：5cm ； <br>记录容量：5万条； <br>工作电压：9至16V； <br>额定功率：约10W； <br>工作温度： -10-50度； <br>存储温度：-30-70度； <br>湿度：相对湿度5%至95%； <br>产品颜色：白色或蓝色； <br>产品尺寸： 250*240*100mm。</div></div><div style="width: 311px;"><img src="/static/img/hardware_5A.png" style="width: 311px; height: 195px;"><img src="/static/img/hardware_5B.png" style="width: 311px; height: 196px; margin-top: 110px;"><img src="/static/img/hardware_5C.png" style="width: 309px; height: 205px; margin-top: 110px;"></div></div></div>',
  six:'<div class="flex width100 justify-between flex-direction"><div class="width100 flex justify-between"><div style="width: 490px;"><div class="size25">AI智能摄像机</div><div class="size18 color-6 padding-top-xs">800万1/1.8” CMOS海康威视AI轻智能抓拍筒型网络摄像机</div><div class="size20 padding-tb-sm font-strong">人脸抓拍</div><div class="color-6 size18">1）支持，同时检测30张人脸，对运动人脸进行检测、跟踪、抓拍、评分、筛选，输出最优的人脸抓图 <br>2）支持人脸小图自定义可设置。 <br>3）支持快速抓拍和最佳抓拍。</div></div><img src="/static/img/hardware_6.png" style="width: 341px; height: 168px;"></div><div class="width100"><div class="size20 padding-tb-xs font-strong">道路监控</div><div class="color-6 size18">车辆检测：支持车牌识别，车型/车标/车身颜色/车牌颜色识别 <br>混行检测：检测正向或逆向行驶的车辆以及行人和非机动车，自动对车辆牌照进行识别，可以抓拍无车牌的车辆图片。 <br>智能补光：补光灯集成白光灯和红外灯，分为白光模式和混合模式，白光模式只开启白光灯，混合模式下是开启红外，另外用白光做补偿。 <br>最低照度：彩色:0.002 Lux @ (F1.2, AGC ON) 黑白:0.0002 Lux @ (F1.2, AGC ON), 0 Lux with IR <br>镜头:（2.8-12mm）@F1.2，水平视场角：100.7°~39.2° <br>宽动态：超宽动态范围达120dB，室内逆光环境下监控 <br>视频压缩标准：H.265/H.264 / MJPEG <br>最大图像尺寸：4096 x 2160 <br>存储功能：Micro SD(即TF卡)/Micro SDHC /Micro SDXC卡(128G)断网本地存储，NAS(NFS、SMB/CIFS均支持) <br>通讯接口：1 个RJ45 10M / 100M /1000M自适应以太网口 1个RS-485接口 <br>视频输出：1Vp-p Composite Output(75Ω/CVBS) <br>音频接口：1对音频输入(Line in )/输出接口 <br>报警接口：2对报警输入/输出接口(报警输出最大支持DC24V 1A或AC30V 500mA) <br>工作温度和湿度：-30℃~60℃,湿度小于95%(无凝结) <br>电源供应：DC：12V；PoE：802.3at，class 4 <br>电源接口类型：三芯电源接口 <br>功耗：DC12V, 1.6A, Max: 19W；PoE(802.3at,42.5-57V), 0.4-0.5A, MAX: 20W <br>防护等级：IP66 <br>补光距离：白光：30米（人脸5米）;混合：30米（人脸7米） <br>红外波长：750nm <br>尺寸(mm)：206.5×103.9×100 <br>重量：1360g。</div></div></div>'
}
const solutionList = {
  one:'<div class="flex width100 justify-between"><div style="width: 100%;"><div class="size25">校园进出解决方案</div><div class="color-6 size18"><img src="/static/img/solution_r1.jpg" style="width: 386px; height: 291px; float: right; margin-left: 75px;"><span class="size20 padding-top-sm flex">秒速识别 刷脸开闸</span>对人脸进行身份认证,并启动闸机、语音播报、信息记录等相关硬件或程序。<br><span class="size20 padding-top-sm flex">来访预约 刷脸识别</span>来访预约,扫码识别,核对放行,提高门禁便捷性,轻松解决传统访客来访的麻烦。<span class="size20 padding-top-sm flex">请假审批 自动放行</span>只需线上提交申请,通过审批,系统便可自动对接,实现刷脸自动放行。<span class="size20 padding-top-sm flex">日志报表 历史可查</span>实时记录考勤、迟到、请假、早退、缺勤;自定义时间下载考勤统计表格。<span class="size20 padding-top-xs">数据统计与推送</span><br>对人脸识别、体温测量、考勤状态等进行数据处理，自动生成数据报表,即刻触达相应的管理员及家长，使其第一时间了解相关信息。<span class="size20 padding-top-sm flex">体温统计</span>实时展示班级、个人体温测量数据,可自定义查询;支持按个人、班级、年级、全校下载数据报表。<span class="size20 padding-top-sm flex">权限设置</span>可设置不同考勤方式的组别,包括考勤时间、人员、位置;按规则进出。</div></div></div>',
  two:'<div class="flex width100 justify-between"><div style="width: 100%;"><div class="size25">智慧班牌管理解决方案</div><div class="color-6 size18"><img src="/static/img/solution_r2.png" style="width: 365px; height: 187px; float: right; margin-left: 75px;"><span class="size20 padding-top-sm padding-bottom-xs flex">云端部署、轻量应用、便捷访问、远程管理；定制需求。</span>智慧班牌是一款校园多媒体交互与信息展示终端，集学生管理、班级管理、校园管理、德育评价于一身，融合学校教务管理、教师管理、考勤、信息发布、班级文明建设、校园风采、家校互通等一系列应用模块，为校园管理现代化、信息化提供有效解决工具。智慧班牌实现了学校、教师、家长、学生的多端信息互通及实时互动，推动智慧校园建设的一体化、数据化、信息化。</div></div></div>',
  three:'<div class="flex width100 justify-between"><div class="size18" style="width: 450px;"><div class="size25">宿舍管理解决方案</div><div class="size20 padding-top-sm">多人考勤</div><div class="color-6">支持多人识别考勤,精准度高,快速比对,信息推送。</div><div class="size20 padding-top-sm">无感识别</div><div class="color-6">动态、非配合、无感知识别,即正常行走的学生,出现在摄像机镜头所覆盖区域内的学生均可同时被识别。</div><div class="size20 padding-top-sm">语音报警</div><div class="color-6">支持人脸比对未识别出的人员统一默认为陌生人,实时大屏展示;当陌生人出现时,系统语音报警;支持自定义语音报警功能。</div><div class="size20 padding-top-sm">信息维护</div><div class="color-6">楼栋、楼层、房间、床位、调寝等数据维护更新。</div><div class="size20 padding-top-sm">时时查寝</div><div class="color-6">支持按寝室展示学生在寝(未归)状态,颜色区分,鲜明直观。</div><div class="size20 padding-top-sm">晚归提醒</div><div class="color-6">支持自定义晚归时间段,系统自动生成晚归学生清单,定时推送给相应管理员。</div></div><div class="flex flex-direction align-end"><img src="/static/img/hardware_6.png" style="width: 341px; height: 168px;"><img src="/static/img/solution_r3.png" style="width: 336px; height: 236px; margin-top: 160px;"></div></div>',
  four:'<div class="flex width100 justify-between"><div class="size18" style="width: 410px;"><div class="size25">智慧食堂解决方案</div><div class="size20 padding-top-sm">功能特点</div><div class="color-6">扣费方式多样 定时段模式 充值方式多样 补贴发放功能 限额限次功能 离线消费功能 支持人脸/二维码/卡片</div><div class="size20 padding-top-sm">学校</div><div class="color-6">提升学校形象和信息化程度；自助充值，减少人工管理；电子账单，账目清晰。</div><div class="size20 padding-top-sm">家长</div><div class="color-6">消费信息实时推送；余额不足提醒，及时充值；消费报告，健康成长。</div><div class="size20 padding-top-sm">食堂</div><div class="color-6">提升支付和对账效率；减少补卡充值，提升工作效率；经营决策，提升管理水平。</div><div class="size20 padding-top-sm">学生</div><div class="color-6">人脸就餐，方便及时；无需现金，安全保障；消费记录，随时查询。</div></div><div class="flex flex-direction align-end"><img src="/static/img/solution_r4.png" style="width: 342px; height: 252px;"><img src="/static/img/solution_r4B.png" style="width: 304px; height: 244px; margin-top: 130px;"></div></div>',
  five:'<div class="flex width100 justify-between"><div class="size18" style="width: 430px;"><div class="size25">校园亲情电话解决方案</div><div class="color-6 padding-top-sm">家长可以在“云知校”留言板中给孩子进行留言，学生在班牌上看到后，通过刷卡或者人脸识别认证登录即可查看，查看后可以回复家长留言，也可以直接拨打预留的手机号，促进孩子在校期间与家长的沟通。</div></div><div class="flex flex-direction align-end"><img src="/static/img/solution_r5.png" style="width: 324px; height: 248px;"></div></div>',
  six:'<div class="flex width100 justify-between"><div class="size18" style="width: 430px;"><div class="size25">在线巡课解决方案</div><div class="color-6 padding-top-sm">将学校原有监控室直播画面通过移动端直观展示，班主任可在手机端远程实时查看自己班级的学生上课情况，校长及权限领导可以在手机端实时查看所有班级的上课情况。极大的方便了老师对班级和校领导对全校班级的管理。学校也可根据自己的情况选择教学开放时间，家长通过微信公众号进行观看，实时关注孩子在校成长点滴。学校负责人也可将视频画面直播到大屏，用于公开课评审等。</div><div class="color-6 padding-top-sm">权限可分配，如班主任只能查询所在班级，级部负责人查询年级，校领导查询全校等。</div></div><div class="flex flex-direction align-end"><img src="/static/img/solution_r6.png" style="width: 416px; height: 321px; margin-top: 50px;"></div></div>'
}
const caseVideo = [
  {
    id:1,
    url:"https://img.xmyunzhixue.com/official/img/yunzhixun.m4v",
    img:"/static/img/about.jpg",
    title:"厦门云知学"
  }
]
const casePhoto = [
  {
    id:1,
    title:"贵溪市第一中学",
    conten_text:"智慧校园是指以促进信息技术与教育教学融合、提高学与教的效果为目的，以物联网、云计算、大数据分析等新技术为核心技术，提供一种环境全面感知、智慧型、数据化、网络化、协作型一体化的教学、科研、管理和生活服务，并能对教育教学、教育管理进行洞察和预测的智慧学习环境。智慧校园=1个数据中心+智慧校园基础设施 +八类智慧校园应用系统+智慧性资源。八类智慧校园应用系统分别是：学生成长类智慧应用系统、教师专业发展类智慧应用系统、科学研究类智慧应用系统、教育管理类智慧应用系统、安全监控类智慧应用系统、后勤服务类智慧应用系统、社会服务类智慧应用系统、综合评价类智慧应用系统 。",
    photo_title:"案例相册",
    photo_number:"6",
    img:"/static/img/about.jpg",
  }
]
const caseImgShow = [
  {
    id:1,
    img:"/static/img/case_1.jpg"
  },
  {
    id:2,
    img:"/static/img/case_2.jpg"
  },
  {
    id:3,
    img:"/static/img/case_3.jpg"
  },
  {
    id:4,
    img:"/static/img/case_4.jpg"
  },
  {
    id:5,
    img:"/static/img/case_5.jpg"
  },
  {
    id:6,
    img:"/static/img/case_6.jpg"
  }
]
const mSolutionList = {
  one:{
    id:1,
    title:"校园进出解决方案",
    img:['/static/img/solution_r1.jpg'],
    text:'<div class="width100 bg-white flex flex-direction padding"><div class="size18 font-strong padding-top-sm">秒速识别 刷脸开闸</div><div class="padding-bottom-lg">对人脸进行身份认证,并启动闸机、语音播报、信息记录等相关硬件或程序。</div><div class="size18 font-strong">来访预约 刷脸识别</div><div class="padding-bottom-lg">来访预约,扫码识别,核对放行,提高门禁便捷性,轻松解决传统访客来访的麻烦。</div><div class="size18 font-strong">请假审批 自动放行</div><div class="padding-bottom-lg">只需线上提交申请,通过审批,系统便可自动对接,实现刷脸自动放行。</div><div class="size18 font-strong">日志报表 历史可查</div><div class="padding-bottom-lg">实时记录考勤、迟到、请假、早退、缺勤;自定义时间下载考勤统计表格。</div><div class="size18 font-strong">数据统计与推送</div><div class="padding-bottom-lg">对人脸识别、体温测量、考勤状态等进行数据处理，自动生成数据报表,即刻触达相应的管理员及家长，使其第一时间了解相关信息。</div><div class="size18 font-strong">体温统计</div><div class="padding-bottom-lg">实时展示班级、个人体温测量数据,可自定义查询;支持按个人、班级、年级、全校下载数据报表。</div><div class="size18 font-strong">权限设置</div><div class="padding-bottom-lg">可设置不同考勤方式的组别,包括考勤时间、人员、位置;按规则进出。</div></div>'
  },
  two:{
    id:2,
    title:"智慧班牌管理解决方案",
    img:['/static/img/solution_r2.png'],
    text:'<div class="width100 bg-white flex flex-direction padding"><div class="size18 font-strong padding-top-sm">云端部署、轻量应用、便捷访问、远程管理；定制需求。</div><div class="padding-bottom-lg">智慧班牌是一款校园多媒体交互与信息展示终端，集学生管理、班级管理、校园管理、德育评价于一身，融合学校教务管理、教师管理、考勤、信息发布、班级文明建设、校园风采、家校互通等一系列应用模块，为校园管理现代化、信息化提供有效解决工具。智慧班牌实现了学校、教师、家长、学生的多端信息互通及实时互动，推动智慧校园建设的一体化、数据化、信息化。</div></div>'
  },
  three:{
    id:3,
    title:"宿舍管理解决方案",
    img:['/static/img/hardware_6.png','/static/img/solution_r3.png'],
    text:'<div class="width100 bg-white flex flex-direction padding"><div class="size18 font-strong padding-top-sm">多人考勤</div><div class="padding-bottom-lg">支持多人识别考勤,精准度高,快速比对,信息推送。</div><div class="size18 font-strong">无感识别</div><div class="padding-bottom-lg">动态、非配合、无感知识别,即正常行走的学生,出现在摄像机镜头所覆盖区域内的学生均可同时被识别。</div><div class="size18 font-strong">语音报警</div><div class="padding-bottom-lg">支持人脸比对未识别出的人员统一默认为陌生人,实时大屏展示;当陌生人出现时,系统语音报警;支持自定义语音报警功能。</div><div class="size18 font-strong">信息维护</div><div class="padding-bottom">楼栋、楼层、房间、床位、调寝等数据维护更新。</div><div class="size18 font-strong">晚归提醒</div><div class="padding-bottom-lg">支持自定义晚归时间段,系统自动生成晚归学生清单,定时推送给相应管理员。</div></div>'
  },
  four:{
    id:4,
    title:"智慧食堂解决方案",
    img:['/static/img/solution_r4.png','/static/img/solution_r4B.png'],
    text:'<div class="width100 bg-white flex flex-direction padding"><div class="size18 font-strong padding-top-sm">功能特点</div><div class="padding-bottom-lg">扣费方式多样 定时段模式 充值方式多样 补贴发放功能 限额限次功能 离线消费功能 支持人脸/二维码/卡片</div><div class="size18 font-strong">学校</div><div class="padding-bottom-lg">提升学校形象和信息化程度;自助充值，减少人工管理;电子账单，账目清晰。</div><div class="size18 font-strong">家长</div><div class="padding-bottom-lg">消费信息实时推送；余额不足提醒，及时充值；消费报告，健康成长。</div><div class="size18 font-strong">食堂</div><div class="padding-bottom-lg">提升支付和对账效率；减少补卡充值，提升工作效率；经营决策，提升管理水平。</div><div class="size18 font-strong">学生</div><div class="padding-bottom-lg">人脸就餐，方便及时；无需现金，安全保障；消费记录，随时查询。</div></div>'
  },
  five:{
    id:5,
    title:"校园亲情电话解决方案",
    img:['/static/img/solution_r5.png'],
    text:'<div class="width100 bg-white flex flex-direction padding"><div class="padding-bottom-lg padding-top-sm">家长可以在“云知校”留言板中给孩子进行留言，学生在班牌上看到后，通过刷卡或者人脸识别认证登录即可查看，查看后可以回复家长留言，也可以直接拨打预留的手机号，促进孩子在校期间与家长的沟通。</div></div>'
  },
  six:{
    id:6,
    title:"在线巡课解决方案",
    img:['/static/img/solution_r6.png'],
    text:'<div class="width100 bg-white flex flex-direction padding"><div class="padding-bottom-lg paddingh-top-sm">将学校原有监控室直播画面通过移动端直观展示，班主任可在手机端远程实时查看自己班级的学生上课情况，校长及权限领导可以在手机端实时查看所有班级的上课情况。极大的方便了老师对班级和校领导对全校班级的管理。学校也可根据自己的情况选择教学开放时间，家长通过微信公众号进行观看，实时关注孩子在校成长点滴。学校负责人也可将视频画面直播到大屏，用于公开课评审等。 </div><div class="padding-bottom-lg">权限可分配，如班主任只能查询所在班级，级部负责人查询年级，校领导查询全校等；</div></div>'
  }
}
const mHardwareList = {
  one:{
    id:1,
    title:"人脸识别一体机",
    img:['/static/img/hardware_1.png'],
    text:'<div class="width100 bg-white flex flex-direction padding"><div class="size18 font-strong padding-top-sm">技术参数</div><div class="padding-bottom-lg">操作系统：嵌入式Linux操作系统 <br>显示屏尺寸：7英寸 <br>屏幕比例：16:9 <br>分辨率：1024*600 <br>摄像头：200万像素1080P，自动对焦，适应120cm-200cm身高范围 <br>卡类型：13．56MHz Mifare卡、身份证序列号、CPU序列号 <br>刷脸验证时间 ：1：N人脸比对时间≤0.2S/人 <br>人脸验证准确率 ：≥99% <br>面部识别距离 ：大于2m <br>人脸容量： 5000张/50000张 <br>存储容量 ：50000张卡，100000条事件记录 <br>通讯方式： 10/100/1000Mbps自适应网口 <br>物理接口 ：RS485*1、Wiegand * 1(支持双向)、USB*2、电锁*1、门磁*1、报警输入*2、报警输出*1、开门按钮*1 <br>设备电源 ：DC 12V/3A（不带电源，集中供电） <br>设备功率 ：25W <br>相对湿度 ：0%至90%(在不凝结水滴状态下) <br>工作温度 ：-30℃～60℃ <br>使用环境 ： IP65</div></div>'
  },
  two:{
    id:2,
    title:"人脸识别测温一体机",
    img:['/static/img/hardware_2.png'],
    text:'<div class="width100 bg-white flex flex-direction padding"><div class="size18 font-strong padding-top-sm">技术参数</div><div class="padding-bottom-lg">【测温、人脸识别】 <br>设备外观：采用7英寸触摸显示屏，200万像素双目摄像头，面部识别距离0.5m-1.5m； <br>设备容量：支持50000张人脸白名单，50000张卡，100000条记录存储；<br>体温检测：非接触式体温检测，温度检测距离在0.5m~1.5m之间，测温精度±0.5℃； <br>认证方式：支持人脸识别、刷卡、密码（密码）及组合认证方式，识别人员身份后获取该人员体温数据统一绑定；<br>通讯方式：有线网络； <br>设备接口： LAN*1；RS485*1；韦根*1；USB *2；门磁*1、开门按钮*1、报警输入*2；电锁*1、报警输出*1； <br>传感器类型：氧化钒(VOx)微测辐射热计（热成像测温）；<br>工作电压：DC 12V/2A，不自带电源； <br>使用环境：室内，无风环境； <br>安装方式：标配金属安装挂板，支持明装、86底盒安装； <br>外观尺寸：285*116.5*35mm <br>工作温度：0℃-50℃。</div></div>'
  },
  three:{
    id:3,
    title:"翼闸/摆闸",
    img:['/static/img/hardware_3A.png','/static/img/hardware_3B.png'],
    text:'<div class="width100 bg-white flex flex-direction padding"><div class="size18 font-strong padding-top-sm">翼闸-技术参数</div><div class="padding-bottom-lg">尺寸：L1200*W300*H980mm； <br>材料SUS304 国标厚度：盖面1.5mm，机箱1.2mm； 通行人数：40人/分钟 ； <br>红外：对开配3对,断电自动打开,上电自动复位； <br>通行方向：双向读卡窗、方向指示； <br>翼门长度：28CM； <br>对开通道宽度：55CM； <br>工作环境：室内 /室外，室外底部要做隔潮安全岛。</div><div class="size18 font-strong padding-top-sm">翼闸-技术参数</div><div class="padding-bottom-lg">尺寸：L1200*W300*H980mm；<br>材料SUS304 国标厚度：盖面1.5mm，机箱1.2mm； 通行人数：40人/分钟 ；<br>红外：对开配3对,断电自动打开,上电自动复位；<br>通行方向：双向读卡窗、方向指示；<br>翼门长度：28CM；<br>对开通道宽度：55CM；<br>工作环境：室内 /室外，室外底部要做隔潮安全岛。</div></div>'
  },
  four:{
    id:4,
    title:"智慧班牌",
    img:['/static/img/hardware_4A.png','/static/img/hardware_4B.png'],
    text:'<div class="width100 bg-white flex flex-direction padding"><div class="size18 font-strong padding-top-sm">外观结构</div><div class="padding-bottom-lg">产品功能：整机为安卓系统一体机，内置安卓系统、集成刷卡模块无需另配刷卡器、喇叭、无线功能等，可壁挂； <br>2）产品规格：显示尺寸21.5寸； <br>3）交互方式：触摸</div><div class="size18 font-strong padding-top-sm">功能特性</div><div class="padding-bottom-lg">21.5英寸TFT显示屏，分辨率≧1920*1080，屏幕比例16：9，显示颜色：8bitRGB，点间距：0.24795 mm×0.24795 mm；对比度：≧1000:1，亮度:≥280 cd/m²，可视角度（水平/垂直）:≧178°/178°，响应时间：≦14ms； <br>2）前置宽动态、≥200万像素摄像头，内置人脸比对算法（提供标准SDK供第三方调用） <br>3) 内置全向麦克风； <br>4) 支持ISO14443 TypeA、TypeB刷卡签到功能； <br>5) 2路USB接口，支持外接鼠标、U盘等； <br>6) 1路RJ45网线接口；<br>7) 标配电源开关按钮； <br>8) 内置WIFI无线功能，协议支持802.11 b/g/n；<br>9) 喇叭：2x8Ω/2W 箱体喇叭； <br>10）输入电源：220V；功耗：≤30W。 <br>11）支持通过韦根信号控制门禁主机或开关量直接控制门锁 <br>12）产品尺寸：529.96mm×521.69mm×27.2mm</div><div class="size18 font-strong padding-top-sm">操作系统</div><div class="padding-bottom-lg">1) Android智能操作系统6.0以上，稳定可靠； <br>2) 系统内存：≧2G内存保证系统最优性能； <br>3) 系统CPU：Cortex-A17,四核1.8GHZ主频保证系统快速运行； <br>4)）系统存储空间：内置16G emmc。</div></div>'
  },
  five:{
    id:5,
    title:"智慧班牌",
    img:['/static/img/hardware_5A.png','/static/img/hardware_5B.png','/static/img/hardware_5C.png'],
    text:'<div class="width100 bg-white flex flex-direction padding"><div class="size18 font-strong padding-top-sm">技术参数</div><div class="padding-bottom-lg">操作系统：Android 6.0.1 ； <br>主控芯片：RK3288（四核Cortex-A17+GPU Mail-T764,Up to 1.8G）； <br>内存：闪存：2GB； <br>存储：16GB； <br>显示屏：操作端：5寸高清屏； <br>用户端：8寸高清屏； <br>触摸：8寸支持触摸 <br>分辨率：5寸：480 * 800； 8寸：800 * 1280； <br>人脸识别：双目活体； <br>网络通讯方式：支持有线TCP、WIFI、4G； <br>支持SIM卡：移动、联通、电信4G； <br>4G通信支持以下频段：GPRS 850MHz /900MHz /1800MHz /1900MHz； <br>扬声器：单声道8R3W，响度90dB，无破音； <br>读卡频率：200ms； <br>卡片类型：IC卡； <br>IC卡支持13.56MHZ频段（ISO14443A读/写模式）； <br>感应距离：5cm ； <br>记录容量：5万条； <br>工作电压：9至16V； <br>额定功率：约10W； <br>工作温度： -10-50度； <br>存储温度：-30-70度； <br>湿度：相对湿度5%至95%； <br>产品颜色：白色或蓝色； <br>产品尺寸： 250*240*100mm。</div></div>'
  },
  six:{
    id:6,
    title:"AI智能摄像机",
    img:['/static/img/hardware_6.png'],
    text:'<div class="width100 bg-white flex flex-direction padding"><div class="padding-bottom-lg">800万1/1.8” CMOS海康威视AI轻智能抓拍筒型网络摄像机</div><div class="size18 font-strong padding-top-sm">人脸抓拍</div><div class="padding-bottom-lg">1）支持，同时检测30张人脸，对运动人脸进行检测、跟踪、抓拍、评分、筛选，输出最优的人脸抓图 <br>2）支持人脸小图自定义可设置。 <br>3）支持快速抓拍和最佳抓拍。</div><div class="size18 font-strong padding-top-sm">道路监控</div><div class="padding-bottom-lg">车辆检测：支持车牌识别，车型/车标/车身颜色/车牌颜色识别 <br>混行检测：检测正向或逆向行驶的车辆以及行人和非机动车，自动对车辆牌照进行识别，可以抓拍无车牌的车辆图片。 <br>智能补光：补光灯集成白光灯和红外灯，分为白光模式和混合模式，白光模式只开启白光灯，混合模式下是开启红外，另外用白光做补偿。 <br>最低照度：彩色:0.002 Lux @ (F1.2, AGC ON) 黑白:0.0002 Lux @ (F1.2, AGC ON), 0 Lux with IR <br>镜头:（2.8-12mm）@F1.2，水平视场角：100.7°~39.2° <br>宽动态：超宽动态范围达120dB，室内逆光环境下监控 <br>视频压缩标准：H.265/H.264 / MJPEG <br>最大图像尺寸：4096 x 2160 <br>存储功能：Micro SD(即TF卡)/Micro SDHC /Micro SDXC卡(128G)断网本地存储，NAS(NFS、SMB/CIFS均支持) <br>通讯接口：1 个RJ45 10M / 100M /1000M自适应以太网口 1个RS-485接口 <br>视频输出：1Vp-p Composite Output(75Ω/CVBS) <br>音频接口：1对音频输入(Line in )/输出接口 <br>报警接口：2对报警输入/输出接口(报警输出最大支持DC24V 1A或AC30V 500mA) <br>工作温度和湿度：-30℃~60℃,湿度小于95%(无凝结) <br>电源供应：DC：12V；PoE：802.3at，class 4 <br>电源接口类型：三芯电源接口 <br>功耗：DC12V, 1.6A, Max: 19W；PoE(802.3at,42.5-57V), 0.4-0.5A, MAX: 20W <br>防护等级：IP66 <br>补光距离：白光：30米（人脸5米）;混合：30米（人脸7米） <br>红外波长：750nm <br>尺寸(mm)：206.5×103.9×100 <br>重量：1360g。</div></div>'
  }
}
const mHardwareMenu = [
  {
    id:1,
    text:"人脸识别一体机",
  },
  {
    id:2,
    text:"人脸识别测温一体机",
  },
  {
    id:3,
    text:"翼闸/摆闸",
  },
  {
    id:4,
    text:"智慧班牌",
  },
  {
    id:5,
    text:"人脸识别消费机",
  },
  {
    id:6,
    text:"AI智能摄像机",
  }
]
const mSolutionMenu = [
  {
    id:1,
    text:"校园进出解决方案",
  },
  {
    id:2,
    text:"智慧班牌管理解决方案",
  },
  {
    id:3,
    text:"宿舍管理解决方案",
  },
  {
    id:4,
    text:"智慧食堂解决方案",
  },
  {
    id:5,
    text:"校园亲情电话解决方案",
  },
  {
    id:6,
    text:"在线巡课解决方案",
  }
]
const mCaseMenu = [
  {
    id:1,
    text:"案例视频",
  },
  {
    id:2,
    text:"佛山市城北中学",
  }
]
const mCaseList = {
  two:{
    id:1,
    title:"贵溪市第一中学",
    conten_text:"智慧校园是指以促进信息技术与教育教学融合、提高学与教的效果为目的，以物联网、云计算、大数据分析等新技术为核心技术，提供一种环境全面感知、智慧型、数据化、网络化、协作型一体化的教学、科研、管理和生活服务，并能对教育教学、教育管理进行洞察和预测的智慧学习环境。智慧校园=1个数据中心+智慧校园基础设施 +八类智慧校园应用系统+智慧性资源。八类智慧校园应用系统分别是：学生成长类智慧应用系统、教师专业发展类智慧应用系统、科学研究类智慧应用系统、教育管理类智慧应用系统、安全监控类智慧应用系统、后勤服务类智慧应用系统、社会服务类智慧应用系统、综合评价类智慧应用系统 。",
    photo_title:"案例相册",
    photo_number:"6",
    img:"/static/img/about.jpg",
  }
}
const mCasePhoto = ["/static/img/case_1.jpg","/static/img/case_2.jpg","/static/img/case_3.jpg","/static/img/case_4.jpg","/static/img/case_5.jpg","/static/img/case_6.jpg"]
const mCaseVideo = [
  {
    id:1,
    img:"/static/img/about.jpg",
    url:"https://img.xmyunzhixue.com/official/img/yunzhixun.m4v",
    title:"厦门云知学"
  }
]
export default {
	indexTop,
  indexFunction,
  indexSolution,
  indexCase,
  indexAbout,
  indexContact,
  hardwareLeftMenu,
  solutionLeftMenu,
  hardwareList,
  solutionList,
  caseVideo,
  casePhoto,
  caseImgShow,
  mHardwareList,
  mHardwareMenu,
  mSolutionMenu,
  mSolutionList,
  mCaseMenu,
  mCaseList,
  mCasePhoto,
  mCaseVideo
}



// WEBPACK FOOTER //
// ./src/Json.js